module.exports = __webpack_public_path__ + "static/assets/13bd951b42b52db5dd945271b02f98bb.gif";